import React, {ReactElement} from 'react';
import {useSelector} from 'react-redux';
import {Icon} from '@iconify/react';
import {pointsSelector} from '../../store/selectors/runfile.selectors';
import {loadedPresentationSelector} from '../../store/selectors/presentation.selectors';
import {usePresentationMode} from '../../hooks/usePresentationMode';

function Points(): ReactElement {
    const points = useSelector(pointsSelector);
    const presentation = useSelector(loadedPresentationSelector);
    const {showPoints} = usePresentationMode();

    if (!showPoints || !presentation?.gameConfig.isGamificationOn) return <div />;

    return (
        <div className="c-score">
            <Icon icon="fa6-solid:trophy" />
            <span>{points || '0'}</span>
        </div>
    );
}

export default Points;
